/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createTearSheetFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type TearSheet } from '../../../../../../models/index.js';
// @ts-ignore
import { type ViewedRequestBuilder, ViewedRequestBuilderRequestsMetadata } from './viewed/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v1/organizations/{organizationId}/tearsheets/{tearSheetId}
 */
export interface WithTearSheetItemRequestBuilder extends BaseRequestBuilder<WithTearSheetItemRequestBuilder> {
    /**
     * The viewed property
     */
    get viewed(): ViewedRequestBuilder;
    /**
     * Retrieves a single TearSheet by its ID for the specified organization
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TearSheet>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithTearSheetItemRequestBuilderGetQueryParameters> | undefined) : Promise<TearSheet | undefined>;
    /**
     * Retrieves a single TearSheet by its ID for the specified organization
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithTearSheetItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Retrieves a single TearSheet by its ID for the specified organization
 */
export interface WithTearSheetItemRequestBuilderGetQueryParameters {
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithTearSheetItemRequestBuilderUriTemplate = "{+baseurl}/api/v1/organizations/{organizationId}/tearsheets/{tearSheetId}{?useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithTearSheetItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithTearSheetItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    viewed: {
        requestsMetadata: ViewedRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithTearSheetItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithTearSheetItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createTearSheetFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
